/** @format */

import { Adjustment } from './adjustment.interface';
import { KeyValue } from '../key-value';
import { ProxyDetails } from './proxy-pickup.interface';

export interface OrderItem {
  adjustments: Adjustment[];
  attributes: KeyValue<string>[];
  bopisItem: boolean;
  deliveryMethod: string;
  distributedOrderDiscountPerUnit: number;
  ecode: string;
  endDate?: string;
  estimatedDelivery: string;
  fulfillmentMethod: string;
  fulfillmentStore: string;
  hasWarranty?: boolean;
  imageIdentifier: string;
  itemDiscountPerUnit: number;
  itemType?: string;
  name: string;
  nonMerchaDetails?: NonMerchaDetail[];
  orderTracking?: any;
  pdpPageUrl?: string;
  pdpSeoUrl: string;
  presaleEndDate?: string;
  productID: string;
  proxyDetails: ProxyDetails;
  quantity: number;
  shipModeCode: string;
  shippingDiscountPerUnit: number;
  shippingPaidPerUnit: number;
  shippingRecipient?: {
    firstName?: string;
    lastName?: string;
    address?: {
      address1?: string;
      address2?: string;
      address3?: string;
      city?: string;
      country?: string;
      postalCode?: string;
      state?: string;
    };
    email?: string;
    loyaltyAccount?: string;
    phone?: string;
  };
  sku: string;
  startEstimatedDelivery?: string;
  startDate?: string;
  status: string;
  store: string;
  taxPerUnit: number;
  totalAdjustment: number;
  totalPrice: number;
  trackingLocation: string;
  trackingNumber: string;
  trackingStatus: string;
  trackingUrl: string;
  unitPrice: number;
}

export interface NonMerchaDetail {
  displayName: string;
  price: number;
  quantity: number;
  sku: number;
  type: string;
}
